import { ClientRoutes } from "../../Constants/ClientRoutingConstants";
import LoadingPage from "../Shared/Pages/LoadingPage";
import { useAccountSettingsStore } from "../../Zustand/accountSettingsStore";
import { Navigate } from "react-router-dom";
import useIdentityStore from "../../Zustand/identityStore";

/**
 * This component is responsible for dealing with the account settings.
 * Account settings are fetched in App.tsx and stored in Zustand.
 * This component simply redirects to the default page once settings are loaded.
 */
export default function AccountSettingsPage() {
  const softwareFeatures = useAccountSettingsStore((state) => state.softwareFeatures);
  const user = useIdentityStore((store) => store.user);

  // Show loading if user is logged in but settings haven't been loaded yet
  if (user && softwareFeatures === null) {
    return <LoadingPage />;
  }

  return <Navigate to={ClientRoutes.DefaultPage} replace/>;
}
